import {Palette} from 'hubbl-shared';
import {memo} from 'react';
import styled from 'styled-components';

interface MobileOverlayProps {
  isVisible: boolean;
  onClick: () => void;
}

const Overlay = styled.div<{isVisible: boolean}>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${Palette.almostBlackTransparent60};
  z-index: 998;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  visibility: ${props => (props.isVisible ? 'visible' : 'hidden')};
  transition: all 0.3s ease;
  cursor: pointer;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const MobileOverlay = memo(
  ({isVisible, onClick}: MobileOverlayProps) => {
    return <Overlay isVisible={isVisible} onClick={onClick} />;
  },
);
